import script from "./AIChatAgentSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatAgentSetup.vue?vue&type=script&setup=true&lang=js"

import "./AIChatAgentSetup.vue?vue&type=style&index=0&id=7860e4e9&lang=css"
import "./AIChatAgentSetup.vue?vue&type=style&index=1&id=7860e4e9&lang=css"

const __exports__ = script;

export default __exports__